module.exports = __webpack_public_path__ + "img/002.969339cf.webp";